import React, { Component } from 'react'
import { connect } from 'react-redux'

export function mapStateToProps(state) {
    return {
        ribbonBlocks: state.getIn(['ui', 'modules', 'report', 'ribbon', 'reportBlocks', 'data']),
    }
}

export default function (InnerComponent) {
    @connect(mapStateToProps, null)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
